// extracted by mini-css-extract-plugin
export default {"root":"pvCfUk65BnxdDFDBccOJ","trash":"WGvYolJEcOV3r7bvHh5Q"};